import { PopoverAnchor as Anchor, PopoverTrigger as Trigger } from "reka-ui";

import Content from "./Content.vue";
import Root from "./Root.vue";

export type { SearchComboboxOption } from "./context";

export default { Root, Trigger, Anchor, Content };
